<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="pa-5">
        <v-card :loading="loading" class="pa-5" flat>
          <qr-management
            ref="qrManage"
            v-model="data"
            :qr-domain="domain"
            :qrId="slug"
          />

          <v-card-actions class="justify-end">
            <div class="rowinfo justify-end">
              <v-btn
                :disabled="loading"
                :loading="loading"
                class="submit-btn mt-0"
                @click="setSettings"
              >
                <span class="fa fa-save ml-1" style="font-size: 15px"></span>
                بروزرسانی تنظیمات
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-Qr-data-update-setting`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="بروزرسانی تنظیمات"
              />
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement.vue";
import { mapActions } from "vuex";

export default {
  name: "settingEdit",

  components: { QrManagement },

  data: () => ({
    serviceName: "Qrland",
    componentName: "settingEdit",
    helpData: [],
    data: {},
    createdId: null,
    loading: false,
    qrDesign: {},
  }),

  mounted() {
    this.fetch();
  },

  computed: {
    slug() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    domain() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
  },

  methods: {
    ...mapActions("localstorage", ["setQrType", "setCreatedQrID"]),
    fetch() {
      this.loading = true;
      this.$api
        .get(this.$route.fullPath.includes("qr/setting2")
            ?`/v1/testQr/find1/${this.domain}`:
          `/v1/testQr/find/${this.domain}${!!this.slug ? "/" + this.slug : ""}`
        )
        .then(({ data }) => {
          let d = data.data;
          this.data = data.data;
          this.setQrType(d.type);
          this.setCreatedQrID(d.id);
          // this.$nextTick(() => {
          //   this.fetchSettings()
          // })
        })
        .finally(() => (this.loading = false));
    },
    setSettings() {
      this.loading = true;
      this.$refs.qrManage
        .update()
        .then((data) => {
          this.goto("qr/list");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
